import {
  EXTERNAL_LINKS,
  REGISTRATION_ENABLED,
  SITE_URL,
  STORE_LINKS,
} from "~/lib/constants";

export function isRegistrationEnabled(): boolean {
  return REGISTRATION_ENABLED;
}

export function getDevAuthDefaults() {
  return {
    email: "",
    password: "",
    firstName: "",
    lastName: "",
  };
}

export function getStoreLinks() {
  return {
    ios: STORE_LINKS.ios,
    android: STORE_LINKS.android,
  };
}

export function getSiteUrl() {
  return SITE_URL;
}

export function getExternalLinks() {
  return { ...EXTERNAL_LINKS };
}
